// Hook - POST promote user na role handlowca.
// POST /api/ui/trader-management/traders/promote

import { axios } from 'api';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostPromoteUserRequest,
  IPostPromoteUserResponse,
} from 'api/types/traderManagement';

const postPromoteUserToTrader = (
  payload: IPostPromoteUserRequest
): Promise<IPostPromoteUserResponse> =>
  axios.post('/trader-management/traders/promote', payload);

export const usePostPromoteUserToTrader = (
  options?: UseMutationOptions<IPostPromoteUserResponse, IError, IPostPromoteUserRequest>
) => {
  const queryClient = useQueryClient();

  return useMutation<IPostPromoteUserResponse, IError, IPostPromoteUserRequest>(
    (payload) => postPromoteUserToTrader(payload),
    {
      ...(options ?? {}),
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['trader-management-traders']);
        queryClient.invalidateQueries(['trader-management-users-to-promote']);
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
